<template>
<div class="view-leaps-challenge-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" @click="updateHideViewLeapsMeditationOverlayFlag($event)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Title:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.MeditationTitle}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Caption File:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  <div v-if="objToPass.CaptionUrl !== undefined && objToPass.CaptionUrl !== 'undefined' && objToPass.CaptionUrl !== null && objToPass.CaptionUrl !== 'null' && objToPass.CaptionUrl !== ''">
                    <a target="_blank" class="text-color-blue" :href="objToPass.CaptionUrl"><u>Download File</u></a>
                  </div>
                  <div class="text-color-red" v-else>
                    Not Found.
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Created TS:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.CreatedTS}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Updated TS:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  {{objToPass.UpdatedTS}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Video:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  <div v-if="objToPass.VideoUrl !== undefined && objToPass.VideoUrl !== null && objToPass.VideoUrl !== 'null' && objToPass.VideoUrl !== ''">
                    <video width="100%" height="100%" controls controlsList="nodownload">
                      <source v-bind:src="objToPass.VideoUrl" type="video/mp4">  
                    </video>
                  </div>
                  <div v-else class="text-color-red">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Audio:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  <div v-if="objToPass.AudioUrl !== undefined && objToPass.AudioUrl !== null && objToPass.AudioUrl !== 'null' && objToPass.AudioUrl !== ''">
                    <audio controls class="audio-width" controlsList="nodownload">
                      <source :src="objToPass.AudioUrl" type="audio/mp3">
                    </audio>
                  </div>
                  <div v-else class="text-color-red">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                </div>
                <div class="col-md-3 col-lg-3 text-align-center padding-left-0Px">
                  
                  <span class="margin-right-15px">
                    Low:
                    <span class="glyphicon glyphicon-ok-circle opacity0Point5" v-if="objToPass.LowQualityVideoUrl == undefined || objToPass.LowQualityVideoUrl == null || objToPass.LowQualityVideoUrl == ''"></span>
                    <span class="glyphicon glyphicon-ok-circle orangeColor" v-else></span>
                  </span>
                      
                  <span class="margin-right-15px">
                    Auto:
                    <span class="glyphicon glyphicon-ok-circle opacity0Point5" v-if="objToPass.VideoUrl == undefined || objToPass.VideoUrl == null || objToPass.VideoUrl == ''"></span>
                    <span class="glyphicon glyphicon-ok-circle orangeColor" v-else></span>
                  </span>
                  
                  <span class="margin-right-15px">
                    High:
                    <span class="glyphicon glyphicon-ok-circle opacity0Point5" v-if="objToPass.HDVideoUrl == undefined || objToPass.HDVideoUrl == null || objToPass.HDVideoUrl == ''"></span>
                    <span class="glyphicon glyphicon-ok-circle orangeColor" v-else></span>
                  </span>

                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Description:</b>
                </div>
                <div class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <span v-html="objToPass.MeditationDescription"></span>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateHideViewLeapsMeditationOverlayFlag($event)">Close</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['currSelectedObj'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      constants: constants,
      objToPass: {
        MeditationLibraryId: '',
        MeditationTitle: '',
        MeditationDescription: '',
        CreatedTS: '',
        UpdatedTS: '',
        VideoUrl: '',
        AudioUrl: ''
      }
    }
  },
  name: 'view-leaps-challenge-overlay',
  methods: {
    setDefaultValues: function () {
      this.objToPass.CaptionUrl = this.currSelectedObj.CaptionUrl
      this.objToPass.MeditationLibraryId = this.currSelectedObj.MeditationLibraryId
      this.objToPass.MeditationTitle = this.currSelectedObj.MeditationTitle
      this.objToPass.VideoUrl = this.currSelectedObj.VideoUrl
      this.objToPass.AudioUrl = this.currSelectedObj.AudioUrl
      this.objToPass.CreatedTS = this.currSelectedObj.CreatedTS
      if (this.objToPass.CreatedTS.indexOf('Z') === -1) {
        this.objToPass.CreatedTS += 'Z'
      }
      this.objToPass.CreatedTS = dmAdminUtils.covertUtcToEst(this.objToPass.CreatedTS)
      this.objToPass.UpdatedTS = this.currSelectedObj.UpdatedTS
      if (this.objToPass.UpdatedTS.indexOf('Z') === -1) {
        this.objToPass.UpdatedTS += 'Z'
      }
      this.objToPass.UpdatedTS = dmAdminUtils.covertUtcToEst(this.objToPass.UpdatedTS)
      this.objToPass.MeditationDescription = (this.currSelectedObj.MeditationDescription !== undefined && this.currSelectedObj.MeditationDescription !== 'undefined' && this.currSelectedObj.MeditationDescription !== null && this.currSelectedObj.MeditationDescription !== 'null' && this.currSelectedObj.MeditationDescription !== '' && this.currSelectedObj.MeditationDescription.trim().length !== 0) ? this.currSelectedObj.MeditationDescription : '<span style="color:red">Not Found.</span>'
    },
    updateHideViewLeapsMeditationOverlayFlag: function (event) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {},
  computed: {}
}
</script>

<style scoped>
.text-color-red {
  color: red !important;
}
.text-color-blue {
  color: blue !important;
}
.audio-width {
  width: -webkit-fill-available;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.opacity0Point5 {
  opacity: 0.5;
}
.orangeColor {
  color: #f39c12;
}
.margin-right-15px {
  margin-right: 15px;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/meditation/ViewLeapsMeditationOverlay.vue